module.exports = __webpack_public_path__ + "img/gn_plan_pointer_hover.6785ee0b.svg";